import { WHITELABEL_URI } from './env';
import { WHITELABEL_DEFAULT_LOGO, WHITELABEL_DEFAULT_THUMBNAIL } from './constants';

//exported functions

export const resetWhitelabelEffect = () => {
    localStorage.removeItem("onrampinvest.poid");
    resetWhitelabelCSSProperties();
};

export const getWhitelabelLogo = async () => {
    const orgID = getOrgID();
    if (!orgID || !WHITELABEL_URI) return WHITELABEL_DEFAULT_LOGO;

    const logoUrl = `${WHITELABEL_URI}/${orgID}/logo.png`;

    try {
        const response = await fetch(logoUrl, { method: 'HEAD' });
        if (response.ok) {
            return logoUrl;
        }
        return WHITELABEL_DEFAULT_LOGO;
    } catch (error) {
        console.error(`Failed to fetch whitelabel logo for org ${orgID}`, error);
        return WHITELABEL_DEFAULT_LOGO;
    }
};

export const getWhitelabelThumbnail = async () => {
    const orgID = getOrgID();
    if (!orgID || !WHITELABEL_URI) return WHITELABEL_DEFAULT_THUMBNAIL;

    const thumbnailUrl = `${WHITELABEL_URI}/${orgID}/thumbnail.svg`;

    try {
        const response = await fetch(thumbnailUrl, { method: 'HEAD' });
        if (response.ok) {
            return thumbnailUrl;
        }
        return WHITELABEL_DEFAULT_THUMBNAIL;
    } catch (error) {
        console.error(`Failed to fetch whitelabel thumbnail for org ${orgID}`, error);
        return WHITELABEL_DEFAULT_THUMBNAIL;
    }
};

export const setWhitelabelCSSProperties = async () => {
    const orgID = getOrgID();
    if (!orgID || !WHITELABEL_URI) return;

    const propertiesUrl = `${WHITELABEL_URI}/${orgID}/properties.json`;

    try {
        const head = await fetch(propertiesUrl, { method: 'HEAD' });
        if (!head.ok) return;

        const response = await fetch(propertiesUrl);
        if (response.ok) {
            const properties = await response.json();
            if (properties.cssProperties) {
                applyCSSProperties(properties.cssProperties);
            }
        }
    } catch (error) {
        console.error(`Failed to load whitelabel CSS properties for org ${orgID}`, error);
    }
};

//internal functions

const applyCSSProperties = (cssProperties) => {
    const root = document.querySelector(':root');
    for (const [key, value] of Object.entries(cssProperties)) {
        root.style.setProperty(key, value);
    }
};

const resetWhitelabelCSSProperties = () => {
    const root = document.querySelector(':root');
    const whitelabelVars = ['--color__primary', '--color__secondary', '--color__button--disabled'];
    for (const key of whitelabelVars) {
        root.style.removeProperty(key);
    }
};

const getOrgID = () => {
    const orgID = localStorage.getItem("onrampinvest.poid");
    return orgID ? Number(orgID) : null;
};
